/**
 * Nemovitosti archive — auto-submits the "Upřesnit výběr" refine form.
 *
 * The plugin's form (etrimon-realestate's templates/archive-nemovitost.php)
 * works with no JS at all — a plain GET submit via the "Zobrazit výsledky"
 * button. This is a pure progressive enhancement on top of that: the moment
 * any checkbox in the form changes, it submits itself, so results update
 * immediately instead of waiting for a manual click. Matches the "theme
 * provides styles/JS, the plugin owns the markup and query logic" split
 * Etrimon settled on 2026-08-29 — see the etrimon-realestate-plugin memory
 * for the fuller architecture note.
 *
 * Concatenated after the vendor bundle by the gulp `scripts` task and
 * enqueued with `defer`, so the document is parsed before this runs — no
 * DOMContentLoaded wrapper needed, same reasoning as main.js. Loaded
 * site-wide like every other theme script; harmless everywhere else since
 * the form simply isn't found off the archive.
 */
( function () {
	'use strict';

	var form = document.querySelector( '.listing-refine' );

	if ( ! form ) {
		return;
	}

	form.addEventListener( 'change', function ( event ) {
		if ( event.target.matches && event.target.matches( 'input[type="checkbox"]' ) ) {
			form.submit();
		}
	} );
}() );
